import { Add, CloseRounded } from '@mui/icons-material'
import {
  Box,
  Button,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material'
import { FIELD_EDIT_RENDERERS, FIELD_VIEW_RENDERERS } from './fieldRegistry'

import { useState } from 'react'

const rowSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
}

const LabelValueRow = (props) => {
  const [showInput, setShowInput] = useState(false)

  const readOnlyFields = ['dependent', 'content']
  const canEdit =
    props.isInEditMode &&
    !props.readOnly &&
    !readOnlyFields.includes(props.type)

  // Content is a static display-only text block (text lives in label); always render it.
  if (props.type === 'content') {
    const ViewRenderer = FIELD_VIEW_RENDERERS.content
    return <ViewRenderer {...props} />
  }

  if (props.isInEditMode && !canEdit && props.value == null) {
    return null
  }

  if (canEdit && !props.required && props.value == null && !showInput) {
    return (
      <Box sx={rowSx}>
        <Typography variant="body2" color="text.secondary" noWrap>
          {props.label}
        </Typography>
        <Button
          size="small"
          startIcon={<Add />}
          onClick={() => setShowInput(true)}
        >
          Add
        </Button>
      </Box>
    )
  }

  if (canEdit) {
    const EditRenderer =
      FIELD_EDIT_RENDERERS[props.type] ?? FIELD_EDIT_RENDERERS.default
    if (showInput) {
      return (
        <Stack direction="row" spacing={1} alignItems="flex-start">
          <Box sx={{ flex: 1 }}>
            <EditRenderer {...props} />
          </Box>
          {!props.required && (
            <Tooltip title="Cancel">
              <IconButton
                size="medium"
                onClick={() => {
                  props.onChange(null)
                  setShowInput(false)
                }}
              >
                <CloseRounded fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </Stack>
      )
    }
    return <EditRenderer {...props} />
  }

  const ViewRenderer =
    FIELD_VIEW_RENDERERS[props.type] ?? FIELD_VIEW_RENDERERS.default

  const isFullWidth = props.type === 'issue' || props.type === 'content'

  if (isFullWidth) {
    return <ViewRenderer {...props} />
  }
  return (
    <Box sx={rowSx}>
      <Typography variant="body2" color="text.secondary" noWrap>
        {props.label}
      </Typography>
      <ViewRenderer {...props} />
    </Box>
  )
}

export default LabelValueRow
